import React, { useRef, useState, useEffect } from 'react';
import { NavLink, useLocation} from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { toggleClose } from '../../store/sidebarToggleSlice';
import './style.css';
import Cookies from 'js-cookie';


const iconsPathLight = ['/icons_sidebar/strategy_tracker_dark.png',
    '/icons_sidebar/historical_performance_dark.png',
    '/icons_sidebar/portfolio_analytics_dark.png',
    '/icons_sidebar/backoffice-icon.png',
    '/icons_sidebar/newspaper.png',
    '/icons_sidebar/subscription_dark.png',
    '/icons_sidebar/setting_dark.png']; 

const iconsPathBW = ['/iconsDark/strategy_tracker.png',
    '/iconsDark/historical_performance.png',
    '/iconsDark/portfolio_analytics.png',
    '/icons_sidebar/backoffice-icon.png',
    '/icons_sidebar/newspaper.png',
    '/iconsDark/subscription.png',
    '/iconsDark/setting.png'];

interface toggleProps {
    toggle: any
}
const Sidebar: React.FC<toggleProps> = ({ toggle }) => {
    const sidebarRef: any = useRef(null);
    const { pathname } = useLocation();
    const [userPrivileges, setUserPrivileges] = useState<any>([]);
    const dispatch = useDispatch();
    let active_path: any = ((pathname?.split('/'))[1]).toLowerCase();
    let active_Subpath: any = ((pathname?.split('/'))[2])?.toLowerCase();
    const theme: any = useSelector((state: any) => {
        return state.theme.isTheme;
      })
    const [navLinks, setNavLinks] = useState<any>([
        {
            name: "Live",
            pathname: 'live',
            isOpen: false,
            subLinks: [],
            havePrivilege: true, //Condition will be there like... the user should have logged in with min acces to one product 
        },
        {
            name: "Historical",
            pathname: 'historical',
            isOpen: false,
            subLinks: [
                // { "Commodity Fut - Intraday": "commodityFutIntraday" },
                { "Equity N50- Multiday": "equityMultiday" },
                { "Equity BANK - Multiday": "equityN50BANK" },
                // { "Forex Fut - Intraday": "forexFutIntraday" },
                // { "Forex Fut - Multiday": "forexFutMultiday" },
                // { "Forex Opt - Intraday": "forexOptIntraday" },
                // { "Stock Fut - Intraday": "stockFutIntraday" },
                // { "Stock Index Fut - Intraday": "stockIndexFutIntraday" },
                { "Stock Index Opt - Intraday": "stockindexOptIntraday" },
                // { "Stock Opt - Intraday": "stockOptIntraday" },
                // { "Stock Pair - Intraday": "stockPairIntraday" }
            ],
            havePrivilege: true
        },
        {
            name: "Portfolio",
            pathname: 'portfolio',
            isOpen: false,
            subLinks: [],
            havePrivilege: false
        },
        {
            name: "Backoffice",
            pathname: 'backoffice',
            isOpen: false,
            subLinks: [],
            havePrivilege: false
        },
        // {
        //     name: "News Recommender",
        //     pathname: 'news',
        //     isOpen: false,
        //     subLinks: [],
        //     havePrivilege: false
        // },
        {
            name: "Subscription",
            pathname: 'subscription',
            isOpen: false,
            subLinks: [],
            havePrivilege: true
        },
        {
            name: "Settings",
            pathname: 'settings',
            isOpen: false,
            subLinks: [],
            havePrivilege: true
        }
    ]);

    const sidebarSubLink: any = Object.freeze({
        // 'Commodity Fut - Intraday': 'CFI',
        'Equity N50- Multiday': 'ESM',
        "Equity BANK - Multiday": "EBM",
        // 'Forex Fut - Intraday': 'FFI',
        // 'Forex Fut - Multiday': 'FFM',
        // 'Forex Opt - Intraday': 'FOI',
        // 'Stock Fut - Intraday': 'SFI',
        // 'Stock Index Fut - Intraday': 'IFI',
        'Stock Index Opt - Intraday': 'IOI',
        // 'Stock Opt - Intraday': 'SOI',
        // 'Stock Pair - Intraday':'PTI'
    })


    const insertPrivilegeDataSelector: any = useSelector((state: any) => {
        return (state.privilege.privilege);
    })

    const deletePrivilegeDataSelector: any = useSelector((state: any) => {
        return (state.privilege.deletedPrivilege);
    })


    useEffect(() => {
        let userPrivilegesCode: any = Cookies.get('codesArray');
        let parsedUserPrivilegesCode: any = Cookies.get('codesArray') ? JSON.parse(userPrivilegesCode) : []
        let modifiedCodesArray: any = []
        parsedUserPrivilegesCode.map((privilegeItem: any) => {
            if (['PORTFOLIO', 'BACKOFFICE'].includes(privilegeItem)) {
                modifiedCodesArray.push(privilegeItem)
            } else {
                // let modifiedCode: any = privilegeItem.slice(0,3)==='POL'?(privilegeItem).slice(0, 3):(privilegeItem).slice(1, 3) + String(privilegeItem).charAt(privilegeItem.length - 1);
                let modifiedCode: any = privilegeItem.slice(0,3)==='EBM'?(privilegeItem).slice(0, 3):(privilegeItem).slice(1, 3) + (String(privilegeItem)?.split('-')[0])?.charAt((String(privilegeItem)?.split('-')[0]).length - 1);
                modifiedCodesArray.push(modifiedCode)
            }
        })
        setUserPrivileges(modifiedCodesArray)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [insertPrivilegeDataSelector, deletePrivilegeDataSelector])

    useEffect(() => {
        updateNavLinks()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userPrivileges,toggle])

    const updateNavLinks = () => {
        let isLoggedIn:any = Cookies.get('details') ? Cookies.get('details') : JSON?.stringify([])
            let sidebarSubnavLinkArray: any = [];
            let newNavLinkArray: any = [];
            navLinks.map((navLinkItem: any) => {
                if ((navLinkItem?.subLinks)?.length > 0) {
                    (navLinkItem?.subLinks).map((item: any) => {
                        sidebarSubnavLinkArray.push({ ...item, 'havePrivilege': userPrivileges.includes(sidebarSubLink[Object.keys(item)[0]])})
                    })
                    navLinkItem['subLinks'] = sidebarSubnavLinkArray
                    newNavLinkArray.push(navLinkItem)
                }
                else {
                    if (!['News Recommender', 'Subscription', 'Settings', 'Live', 'Historical'].includes(navLinkItem['name'])) {
                        newNavLinkArray.push({ ...navLinkItem, 'havePrivilege': userPrivileges.includes((navLinkItem['pathname']).toUpperCase()) })
                    }
                    else {
                        newNavLinkArray.push({ ...navLinkItem })
                    }
                }
            })
            setNavLinks(newNavLinkArray)
        
    };

    const handleClickOutside = (event: MouseEvent) => {
        const target: any = event.target as HTMLElement;
        if (!target.matches('.common_click')) {
            dispatch(toggleClose());
        }
    };

    const toggleNavLink = (index: any) => {
        setNavLinks(navLinks.map((navLink: any, i: any) =>
            index === i ? { ...navLink, isOpen: !navLink.isOpen } : navLink
        ));
        if (index !== 1) dispatch(toggleClose())
    };

    const checkingNavigation = (e: any, havePrivilege: any) => {
        if (!havePrivilege) {
            e.preventDefault();
        }
    };


    const renderSubLinks = (navLink: any) => {
        
        return navLink.subLinks.map((subLink: any, subIndex: any) => (
            <div  key={subIndex} className=' common_click sublink_open' onClick={() => { dispatch(toggleClose()) }}>
                {subLink.havePrivilege ? (
                    <NavLink id={((navLink.subLinks)[subIndex][Object.keys(subLink)[0]])?.toLowerCase() === active_Subpath ? 'active_Subpath' : ''} className='sub-nav-links common_click' to={`/${navLink.name.toLowerCase()}/${Object.values(subLink)[0]}`}>
                        {Object.keys(subLink)[0]}
                    </NavLink>
                ) : (
                    <div className="sub-nav-links disabledSubLinks common_click" >{Object.keys(subLink)[0]}</div>
                )}
            </div>
        ));
    };

    const renderNavLink = (navLink: any, index: any) => (
        <NavLink className='common_click' key={index} to={index === 1 ? pathname : `/${navLink.name.toLowerCase()}`} onClick={(e) => { checkingNavigation(e, navLink.havePrivilege) }}>
            <li id={navLink.name.toLowerCase() === active_path ? 'active_ele' : ''} onClick={(e) => { toggleNavLink(index) }} style={{ fontWeight: '600' }} className={navLink.havePrivilege ? 'common_click ' : 'disabled common_click'}>
                <img className='common_click' src={theme==='light'?iconsPathLight[index]:iconsPathBW[index]} width="35px" height="35px" alt={navLink.name} />
                <span className="nav-link common_click" style={{ pointerEvents: 'none' }} >{navLink.name}</span>
                {index === 1 && <span className='dropdown common_click'>
                    <img className='common_click' src='/svgImage/down-arrow.png' width="35px" height="35px" alt="down-arrow" />
                </span>}
                {navLink.isOpen && renderSubLinks(navLink)}
            </li>
        </NavLink>
    );
    document.addEventListener('click', handleClickOutside, true);

    return (
        <div ref={sidebarRef} className={`sidebar common_click ${toggle ? 'show_sideBar' : ''}`}>
            <ul className="nav-links common_click">
                {navLinks.map((navLink: any, index: any) => renderNavLink(navLink, index))}
            </ul>
        </div>
    );
};

export default Sidebar;
